// Add Presenter Pattern to all Backbone Models
// - Set up a presentables hash that maps
//   attributes and model methods. Then call
//   present() method vs toJSON

const ModelPresentable = {
  presentables: {},
  present() {
    const presentable_attrs = _.clone(this.attributes);
    const that = this;
    _.each(this.presentables, (method, name) => {
      presentable_attrs[name] = that[method]();
    });
    return presentable_attrs;
  },
};

_.extend(Backbone.Model.prototype, ModelPresentable);

const CollectionPresentable = {
  presentables: {},
  present() {
    const modelsAttrs = [];
    const { models } = this;
    const that = this;
    _.each(models, function (model) {
      const presentable_attrs = model.present();
      _.each(that.presentables, (method, name) => {
        presentable_attrs[name] = model[method]();
      });
      modelsAttrs.push(presentable_attrs);
    });
    return modelsAttrs;
  },
};

_.extend(Backbone.Collection.prototype, CollectionPresentable);
